module.exports = "/_next/static/images/avatar_6-05a0d1b66d9b368ddc2c615e4a9caf96.png";